var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPleasure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#ec7b47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-255 347 100 100",
    enableBackground: "new -255 347 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-205,367c16.569,0,30,13.431,30,30s-13.431,30-30,30s-30-13.431-30-30S-221.569,367-205,367 M-205,362   c-19.299,0-35,15.701-35,35s15.701,35,35,35s35-15.701,35-35S-185.701,362-205,362L-205,362z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-186.702,405.077C-189.852,412.227-196.988,417-205,417c-8.012,0-15.148-4.773-18.298-11.923   c5.928,0.724,12.068,1.09,18.298,1.09S-192.63,405.8-186.702,405.077 M-183.743,399.663c-0.147,0-0.297,0.011-0.449,0.033   c-6.5,0.95-13.503,1.471-20.808,1.471s-14.309-0.521-20.808-1.471c-0.151-0.022-0.301-0.033-0.449-0.033   c-1.916,0-3.417,1.807-2.91,3.732C-226.342,414.103-216.596,422-205,422c11.596,0,21.342-7.897,24.167-18.605   C-180.326,401.47-181.827,399.663-183.743,399.663L-183.743,399.663z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: -193.002,
    cy: 390.999,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -216.998,
    cy: 390.999,
    r: 5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPleasure);
export default __webpack_public_path__ + "static/media/pleasure.99c2da7c48e1a6a598b750ac7bad19c3.svg";
export { ForwardRef as ReactComponent };